export var env = process.env.NODE_ENV === 'development';
export var isDevEnv = function(callback) {
    if (env) {
        if (typeof callback === 'function') {
            callback();
        }
        return true;
    }
    return false;
};
export function devMessage(message) {
    console.log("%c".concat(message, "\n\u2661 Carina"), 'background: #8457D9; line-height: 1.5; color: white; display: block; padding: 8px 16px;');
}
export function ifDevMessage(message) {
    if (isDevEnv()) {
        devMessage(message);
    }
}
